module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic16.fa1e8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic16.png
// module id = 494
// module chunks = 1